import { type TJsonQuery } from '@/packages/JsonQuery';

export const JSON_QUERY_DEFAULT: TJsonQuery = {
  _type: 'flatsale',
  engine_version: {
    type: 'term',
    value: 2,
  },
};
